module.exports = __webpack_public_path__ + "static/media/quote_assistant.3cd03464.png";